import React, { useState } from "react";
import { useMutation } from "react-query";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import BackBtn from "../lib/BackBtn";
import TicketInPersonForm from "./TicketInPersonForm";
import { TicketInPersonValidationSchema } from "./TicketInPersonValidationSchema";
import { addTicket } from "../../../api/ticket/ticketApi";

function AddTicketInPerson() {
  const [searchParams, setSearchParams] = useSearchParams();
  const pageFromQuery = searchParams.get("page");
  const page = pageFromQuery ? parseInt(pageFromQuery) : 1;
  const navigate = useNavigate();
  const addMutation = useMutation((ticket: any) => addTicket(ticket));
  const initialValues = {
    matchId: 0,
    profilePlatformId: 0,
    attendees: {
      name: "",
      mobile: "",
      national_code: "",
      male: true,
    },
  };

  const goBack = () =>
    navigate({
      pathname: `/ticket-in-person/add-ticket?page=${page}`,
    });

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const formik = useFormik({
    initialValues,
    validationSchema: TicketInPersonValidationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      addMutation.mutate(values, {
        onSuccess: () => {
          toast.success("بلیت حضوری با موفقیت ایجاد شد", {
            position: "top-center",
          });
          setIsLoading(false);
          formik.resetForm();
          addMutation.reset();
          goBack();
        },
        onError: (e: any) => {
          setIsLoading(false);

          const hasErrors = Object.keys(e?.response?.data).length > 0;

          if (hasErrors) {
            const formattedErrors = Object.entries(e?.response?.data).flatMap(
              ([key, value]) => {
                if (Array.isArray(value)) {
                  return value.flatMap((errorObj) => {
                    return Object.entries(errorObj).map(([field, message]) => {
                      return (
                        <div
                          key={`${field}-${message}`}
                        >{`${field}: ${message}`}</div>
                      );
                    });
                  });
                }
                if (typeof value === "object" && value != null) {
                  return Object.entries(value).map(([field, message]) => {
                    return (
                      <div
                        key={`${field}-${message}`}
                      >{`${field}: ${message}`}</div>
                    );
                  });
                }
                return [<div key={key}>{`${key}: ${value}`}</div>];
              }
            );

            toast.error(
              <div>
                <div>لطفاً موارد زیر را اصلاح کنید:</div>
                {formattedErrors}
              </div>,
              {
                position: "top-center",
                autoClose: false,
                closeOnClick: true,
              }
            );
            return;
          }
        },
      });
    },
  });

  return (
    <div className={"card"}>
      <div
        className={
          "card-title mt-5 mb-1 px-10 d-flex align-items-center justify-content-between "
        }
      >
        <h2>صدور بلیت </h2>
        <BackBtn onClick={() => goBack()} />
      </div>
      <TicketInPersonForm
        loading={isLoading}
        formik={formik}
        labels={{ sendBtnLabel: "ذخیره" }}
      />
    </div>
  );
}

export default AddTicketInPerson;
